import * as React from "react"
import bem from "../../../bem"
import SourceCode from "../../common/SourceCode"

import "./Editor.scss"

interface Props {
    title?: string
    source?: string
}

const b = bem.with("NewUI__editor")

export const Editor = ({ title, source }: Props): JSX.Element => (
    <div className={b()}>
        <div className="tw-flex-row-center">
            <div className="tw-flex-grow tw-py-3 tw-px-4">
                <h3>{title}</h3>
            </div>
        </div>
        <div className="separator-line is-dimmed"></div>
        <SourceCode
            className={`${b("source")} tw-pl-1`}
            value={source}
            readOnly={true}
        />
    </div>
)

export default Editor
